module.exports = require("react-ripples");